import { Inbox } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function EmptyState({ title = 'Nothing here yet', description = 'New items will appear here when they are available.' }: { title?: string; description?: string }) {
  return <div className="empty-state"><span className="empty-state__icon"><Inbox /></span><h3>{title}</h3><p>{description}</p><Button variant="secondary" size="sm">Refresh</Button></div>;
}
